import { Plugin } from "@ckeditor/ckeditor5-core";
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import {
    toWidget,
    viewToModelPositionOutsideModelElement
} from '@ckeditor/ckeditor5-widget/src/utils';
import Widget from '@ckeditor/ckeditor5-widget/src/widget';

import ReleaseNoteIcon from './icon/releasenotes.svg';
import { removeDefaultHtmlSpanAttributes } from "../../src/utils";

import { CkeditorConstants } from '../../src/utils/ckeditorconstants';

const {
    PLUGINS: { RELEASE_NOTES },
    htmlElement: { SPAN },
    htmlAttributes: { REL },
    SKOS_EDITORIAL_NOTE_ATTRIBUTE
} = CkeditorConstants

export class ReleaseNotesUI extends Plugin {

    static get requires() {
        return [Widget];
    }

    init() {
        const editor = this.editor;
        this._defineSchema();
        this._defineConverters();
        this.editor.editing.mapper.on(
            'viewToModelPosition',
            viewToModelPositionOutsideModelElement(this.editor.model, viewElement => viewElement.hasClass(RELEASE_NOTES))
        );


        const t = editor.t;
        editor.ui.componentFactory.add(RELEASE_NOTES, locale => {
            const view = new ButtonView(locale);
            view.set({
                label: t('ReleaseNotes'),
                tooltip: true,
                withText: false,
                icon: ReleaseNoteIcon
            });
            const command = editor.commands.get(RELEASE_NOTES);
            command.isEnabled = true;
            command.isOn = true;
            view.bind('isEnabled').to(command);
            view.bind('isOn').to(command);

            this.listenTo(view, 'execute', () => {
                editor.execute(RELEASE_NOTES);
                editor.editing.view.focus();
            });

            return view;
        })
    };

    _defineSchema() {
        const schema = this.editor.model.schema;

        schema.register(RELEASE_NOTES, {
            allowWhere: '$text',
            isInline: true,
            isObject: true,
            allowAttributesOf: '$text',
        });
    }

    _defineConverters() {
        const conversion = this.editor.conversion;
        this.editor.model.schema.addAttributeCheck(context => {
            if (context.endsWith(RELEASE_NOTES)) {
                return true;
            }
        });

        conversion.for('upcast').elementToElement({
            view: {
                name: SPAN
            },
            model: (_viewElement, { writer: modelWriter }) => {
                if (_viewElement?.getAttribute?.(REL) !== SKOS_EDITORIAL_NOTE_ATTRIBUTE) {
                    return;
                }
                return modelWriter.createElement(RELEASE_NOTES, _viewElement.getAttributes())
            }, converterPriority: 'highest'
        }, { priority: 'highest' });


        conversion.for('editingDowncast').elementToElement({
            model: RELEASE_NOTES,
            view: (modelItem, { writer: viewWriter }) => {
                removeDefaultHtmlSpanAttributes(modelItem, this.editor);
                const widgetElement = createReleaseNoteElement(modelItem, viewWriter);
                // Enable widget handling on a placeholder element inside the editing view.
                return toWidget(widgetElement, viewWriter);
            }
        });

        conversion.for('dataDowncast').elementToElement({
            model: RELEASE_NOTES,
            view: (modelItem, { writer: viewWriter }) => {
                removeDefaultHtmlSpanAttributes(modelItem, this.editor);
                return createReleaseNoteElement(modelItem, viewWriter)
            }
        });

        // Helper method for both downcast converters.
        function createReleaseNoteElement(modelItem, viewWriter) {
            const releaseNoteView = viewWriter.createContainerElement(SPAN, Object.fromEntries(modelItem.getAttributes()));

            return releaseNoteView;
        }
    }
}